module.exports = __webpack_public_path__ + "static/ic-immunity-passport-2c2ded7af5084ca854619ae87077193d.svg";